import { createContext } from 'react';

const LeafletMapContext = createContext(null);

export default LeafletMapContext;
